import * as swcHelpers from '@swc/helpers';
import React__default from 'react';

const GoogleMapsContextDefaultValues = {
    googleMapsSettings: {
        apiKey: '',
        defaultCenter: {
            lat: 0,
            lng: 0
        },
        defaultZoom: 0
    }
};
const GoogleMapsContext = /*#__PURE__*/ React__default.createContext(GoogleMapsContextDefaultValues);
const useGoogleMapsContext = ()=>React__default.useContext(GoogleMapsContext)
;
function GoogleMapsProvider({ settings , children  }) {
    return /*#__PURE__*/ React__default.createElement(GoogleMapsContext.Provider, {
        value: {
            googleMapsSettings: swcHelpers.objectSpread({}, settings, {
                defaultZoom: settings.defaultZoom,
                hasCustomZoomLevel: settings.hasCustomZoomLevel
            })
        }
    }, children);
}
function withGoogleMaps(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithGoogleMaps = (props)=>/*#__PURE__*/ React__default.createElement(GoogleMapsContext.Consumer, null, (context)=>/*#__PURE__*/ React__default.createElement(Component, swcHelpers.extends({}, props, {
                settings: context
            }))
        )
    ;
    WithGoogleMaps.displayName = `WithGoogleMaps(${wrappedName})`;
    return WithGoogleMaps;
}
var GoogleMapsContext$1 = GoogleMapsContext;

export { GoogleMapsContextDefaultValues, GoogleMapsProvider, GoogleMapsContext$1 as default, useGoogleMapsContext, withGoogleMaps };
//# sourceMappingURL=GoogleMapsContext.js.map
